@import '../../../utils/global.module.less';

.messages {
    background-color: '#EAEAEA';
    height: calc(100% - 60px);
}

.customShadow:before {
    content: '';
    background-color: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    border-radius: 0px 20px 20px 0px;
    .shadow();
}
.input {
    height: 100%;
    font-size: 20px;
    flex-grow: 1;

    input {
        &:focus {
            border: none !important;
            border-top: 2px dashed #7c7c7c !important;
        }

        outline: 0;
        background-color: transparent;
        border: none !important;
        border-top: 2px dashed #e0e0e0 !important;
        padding: 5px 10px 5px 10px;
        margin-left: 10px;
        width: 100%;
    }
}

.sendButton {
    width: 100px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border-radius: 0 0 20px 0 !important;
}

.taskTitle {
    padding-bottom: 20px;
    padding-right: 10px;
    background:
        linear-gradient(to left, transparent 0%, #fcfcfd 100%),
        linear-gradient(to bottom, #fcfcfd 0%, #fcfcfd 70%, transparent 100%);

    background-size:
        5% 75%,
        100% 100%;

    background-repeat: no-repeat;
    background-position:
        top right,
        top;

    position: absolute;
    left: 15px;
    top: -5x;
    font-family: Hanken Grotesk !important;
    z-index: 10000;
    :global(.taskSectionTitle) {
        font-size: 16px;
        font-family: LustTextItalic;
        color: #102442;
    }
    :global(.taskNameTitle) {
        font-size: 16px;
        font-family: LustTextItalic;
        color: #102442;
        font-weight: 600;
    }
}
.clearButton {
    position: absolute;
    right: -6px;
    bottom: 40px;
    width: 35px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border: 0 !important;
    z-index: 10000;
    opacity: 0.1;
    color: black;
    padding: 2px !important;
    transition: opacity 0.3s !important;
    background-color: transparent !important;
    &:hover {
        opacity: 1;
        cursor: pointer;
    }
}
.inputLineOffset {
    transform: translateY(16px);
}
